import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "明星八卦", path: "/category/star-gossip" },
  { label: "综艺内幕", path: "/category/variety-insider" },
  { label: "影视爆料", path: "/category/film-tv-leaks" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const bgClass = isHome && !scrolled
    ? "bg-transparent"
    : "bg-background-50/95 backdrop-blur-md";

  const textClass = isHome && !scrolled
    ? "text-white"
    : "text-foreground-800";

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${bgClass} ${scrolled ? "border-b border-background-200/60" : ""}`}>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 group">
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${isHome && !scrolled ? "bg-white/20" : "bg-primary-500"}`}>
            <i className={`ri-fire-line text-lg ${isHome && !scrolled ? "text-white" : "text-background-50"}`}></i>
          </div>
          <span className={`font-heading text-xl font-bold tracking-wide whitespace-nowrap ${textClass}`}>
            51吃瓜网
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const isActive = item.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  isActive
                    ? isHome && !scrolled
                      ? "bg-white/20 text-white"
                      : "bg-primary-100 text-primary-700"
                    : `${textClass} hover:${isHome && !scrolled ? "bg-white/10" : "bg-background-100"}`
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="hidden md:block">
          <Link
            to="/about"
            className={`inline-flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isHome && !scrolled
                ? "bg-accent-400 text-foreground-900 hover:bg-accent-300"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className="ri-send-plane-line"></i>
            爆料投稿
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${textClass}`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive = item.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <Link
              to="/about"
              className="mt-2 px-4 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 text-center whitespace-nowrap"
            >
              爆料投稿
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}